// extracted by mini-css-extract-plugin
export default {"wrapper":"success-page_wrapper__J1wFy","btnWrapper":"success-page_btnWrapper__Rgmp5"};